const OLD_GOV_NUMBER_REGEXP = new RegExp(/[a-zA-Z]{3}[0-9]{3}/)
const NEW_GOV_NUMBER_REGEXP = new RegExp(/[a-zA-Z]{2}[0-9]{3}[a-zA-Z]{2}/)


export const formatCarGovNumber = (govNumber: string) => {
  const upperGovNumber = govNumber.toUpperCase()

  if(upperGovNumber.includes("-")) {
    return upperGovNumber.split("-").join(" ")
  }

  if(NEW_GOV_NUMBER_REGEXP.test(upperGovNumber)) {
    const firstTwoLetters = upperGovNumber.substring(0, 2)
    const digits = upperGovNumber.substring(2, 5)
    const lastTwoLetters = upperGovNumber.substring(5, 7)
  
    return `${firstTwoLetters} ${digits} ${lastTwoLetters}`
  }

  if(OLD_GOV_NUMBER_REGEXP.test(upperGovNumber)) {
    const letters = upperGovNumber.substring(0, 3)
    const digits = upperGovNumber.substring(3, 6)
  
    return `${letters} ${digits}`
  }

}